import App from './App'
import { render } from './render'
import './style'
import { getSentryData } from '@util'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
// eslint-disable-next-line
if (__ENV__ === 'publish') {
  Sentry.init({
    dsn: 'https://02653e453abb483a9fd1f55e81824619@sentry.hunliji.com/3',
    integrations: [new Integrations.BrowserTracing()],
    beforeSend(event, hint) {
      if (!event?.user?.id) {
        const { sentryUser, simpleMerchantData } = getSentryData()
        event.user = sentryUser
        event.extra = { merchantInfo: simpleMerchantData }
        event.tags = { isUnhandledException: true }
      }
      return event
    }
  })
}

render(App)
